export default {
  BOARD_ZOOM: 'board_zoom',
}
